import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/energe',
  component: LAYOUT,
  name: 'Energe',
  redirect: '/energe/detail',
  meta: {
    title: '活动说明',
  },
  children: [
    {
      path: 'detail',
      name: 'EnergeDetail',
      meta: {
        title: '活动说明',
      },
      component: () => import('@/views/energe/detail'),
    },
  ],
};
